import type { ReactElement } from "react"
import ImageTooltipMol from "@onestore/hel/dist/components/molecules/ImageTooltipMol"
import ItemsSliderContainerOrg from "@onestore/hel/dist/components/organisms/ItemsSliderContainerOrg"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import BaseContainer from "@gatsby-plugin-generic-page/components/BaseContainer"
import BaseSection from "@gatsby-plugin-generic-page/components/BaseSection"
import Header from "@gatsby-plugin-generic-page/components/Header"
import type { ImageTooltipSliderSectionFlatData } from "@gatsby-plugin-generic-page/fragments/imageTooltipSliderSection"
import assetsSquidexToImageObject from "~/lib/assetsSquidexToImageObject"
import isEmpty from "~/lib/isEmpty"

function ImageTooltipSliderSection({
  header,
  tiles,
  sectionSettings,
}: ImageTooltipSliderSectionFlatData): ReactElement<ImageTooltipSliderSectionFlatData> {
  return (
    <BaseSection {...sectionSettings}>
      <BaseContainer {...sectionSettings?.containerSettings}>
        {!isEmpty(header) ? (
          <PushOrg bottomSpace={6}>
            <Header {...header} />
          </PushOrg>
        ) : null}

        <ItemsSliderContainerOrg
          items={tiles.map((tile) => (
            <ImageTooltipMol
              key={tile.flatData.name}
              tooltip={tile.flatData.tooltipText}
              image={assetsSquidexToImageObject(tile.flatData.tooltipImage, "")}
            />
          ))}
          itemMinWidthSpace={34.5}
          maxItemsToShow={4}
          gapSpace={3}
          hasEqualHeight
        />
      </BaseContainer>
    </BaseSection>
  )
}

export default ImageTooltipSliderSection
